import { render } from "./ColorEditor.vue?vue&type=template&id=2d4f710e"
import script from "./ColorEditor.vue?vue&type=script&lang=js"
export * from "./ColorEditor.vue?vue&type=script&lang=js"

import "./ColorEditor.vue?vue&type=style&index=0&id=2d4f710e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__